<template>
  <div v-if="loading" class="py-4 container-fluid">
    <loader />
  </div>

  <div v-if="!loading" class="py-4 container-fluid">
    <!-- Top bar -->
    <div class="row mb-3">
      <div class="col">
        <button
          style="float: right"
          class="btn btn-primary mr-2"
          @click="showStartSessionModal = true"
        >
          Start New Session
        </button>
        <!-- <button class="btn btn-secondary" @click="filterActiveSessions">
          Show Active Sessions
        </button> -->
      </div>
    </div>

    <!-- Stocktaking Sessions Table -->
    <div class="card">
      <div class="card-header pb-0">
        <h6>Stocktaking Sessions</h6>
      </div>
      <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive p-0">
          <table class="table align-items-center mb-0">
            <thead>
              <tr>
                <th>Session ID</th>
                <th>Session Name</th>
                <th>Store</th>
                <th>Start Date/Time</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="session in sessions" :key="session.id">
                <td>{{ session.id }}</td>
                <td>{{ session.session_name }}</td>
                <td>{{ session.store_name }}</td>
                <td>{{ session.start_datetime }} | {{ session.status }}</td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'badge-success': session.status == 'active',
                      'badge-danger': session.status == 'ended',
                    }"
                  >
                    {{ session.status }}
                  </span>
                </td>
                <td>
                  <a
                    v-if="session.status == 'active'"
                    class="btn btn-sm btn-info m-1 p-1"
                    :href="
                      '/stock_taking_session/' +
                      session.id +
                      '/' +
                      session.store_id
                    "
                  >
                    Continue take
                  </a>
                  <a
                    class="btn btn-sm btn-secondary m-1 p-1"
                    :href="
                      '/stock_taking_session_report/' +
                      session.id +
                      '/' +
                      session.store_id
                    "
                  >
                    Report
                  </a>
                  <button
                    v-if="session.status == 'active'"
                    @click="end_session(session)"
                    class="btn btn-sm btn-danger m-1 p-1"
                  >
                    End Session
                  </button>
                </td>
              </tr>
              <tr v-if="sessions.length === 0">
                <td colspan="6" class="text-center">No sessions found.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Start Session Modal -->
    <div v-if="showStartSessionModal" class="modal-overlay">
      <div class="modal-content">
        <h5>Start Stocktaking Session</h5>
        <div class="form-group">
          <label>Session Name</label>
          <input v-model="newSessionName" type="text" class="form-control" />
        </div>
        <div class="form-group">
          <label>Select Store</label>
          <select v-model="selectedStore" class="form-control">
            <option disabled value="">Select store</option>
            <option v-for="store in stores" :key="store.id" :value="store.id">
              {{ store.store_name }}
            </option>
          </select>
        </div>
        <div class="mt-3">
          <button class="btn btn-primary mr-2" @click="startSession">
            Start
          </button>
          <button
            class="btn btn-secondary"
            @click="showStartSessionModal = false"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loader from "../special_clinics/dialysis/loader.vue";
import { generalApiRequest } from "../../api/apiIndex";

export default {
  name: "StocktakingPage",
  data() {
    return {
      loading: false,
      sessions: [],
      stores: [],
      showStartSessionModal: false,
      newSessionName: "",
      selectedStore: "",
    };
  },
  components: {
    loader,
  },
  mounted() {
    this.fetchSessions();
    this.fetchStores();
  },
  methods: {
    async end_session(session) {
      console.log(session);
      const url = "stocktakes/end/" + session.id;
      const res = await generalApiRequest(url, "POST", {}, 1);
      if (res) {
        this.fetchSessions();
      }
    },
    async fetchSessions() {
      this.loading = true;
      const res = await generalApiRequest("stocktaking-sessions", "GET", {}, 1);
      console.log(res);

      if (res.status === "success") {
        this.sessions = res.data.map((session) => ({
          ...session,
          store_name: session.store ? session.store.store_name : "N/A",
        }));
        this.allSessions = this.sessions;
      }
      this.loading = false;
    },
    async fetchStores() {
      this.loading = true;
      const res = await generalApiRequest(
        "inventory/getCompanyItemStores_for_input",
        "GET",
        {},
        1
      );
      //   console.log(res);
      if (res.status === "success") {
        this.stores = res.data;
      }
      this.loading = false;
    },
    async startSession() {
      if (!this.newSessionName || !this.selectedStore) {
        alert("Fill all fields!");
        return;
      }

      const payload = {
        session_name: this.newSessionName,
        store_id: this.selectedStore,
      };

      const res = await generalApiRequest(
        "stocktakes/create",
        "POST",
        payload,
        1
      );
      if (res.status === "success") {
        this.fetchSessions();
        this.showStartSessionModal = false;
        this.newSessionName = "";
        this.selectedStore = "";
      }
    },
    filterActiveSessions() {
      this.sessions = this.sessions.filter((s) => s.status === "Active");
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background: #fff;
  padding: 1.5em;
  border-radius: 8px;
  width: 400px;
}
.badge {
  padding: 0.4em 0.7em;
  border-radius: 20px;
}
.badge-success {
  background: #28a745;
  color: #fff;
}
.badge-danger {
  background: #dc3545;
  color: #fff;
}
</style>
